import { AbstractValueObject } from './abstract-value-object.model';

export abstract class PrimitiveValueObject<T> extends AbstractValueObject<T> {}
